import { AbilityContext } from '../ability';
import { useAbility } from '@casl/react';
import { AnyMongoAbility } from '@casl/ability';

const usePerm = (): AnyMongoAbility => useAbility(AbilityContext);

export default usePerm;
